import { graphql, useStaticQuery } from 'gatsby';

const useSkill = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsSkill(filter: {}) {
                nodes {
                    nombre,
                    porcentaje
                    nivel
                }
            }
        }
    `);

    return data.allDatoCmsSkill.nodes.map(skill => ({
        nombre: skill.nombre,
        porcentaje: skill.porcentaje,
        nivel: skill.nivel
    }));

}
 
export default useSkill;